module.exports = __webpack_public_path__ + "img/www.cars.com.9fcef610.png";